import { CommonModule } from '@angular/common';
import {
  Component,
  HostBinding,
  Injector,
  ViewEncapsulation,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { indicate } from '@clean-code/shared/common';
import { BaseWidgetTypeContentComponent } from '@clean-code/shared/components/ui-dashboard';
import { ProgressBarComponent } from '@clean-code/shared/components/ui-progress-bar';
import { TranslocoModule } from '@jsverse/transloco';
import { BehaviorSubject, type Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  shareReplay,
  switchMap,
} from 'rxjs/operators';
import type {
  MarketCustomerAnalysisWidgetLayout,
  MarketCustomerAnalysisWidgetTypeConfig,
} from '../market-customer-analysis-widget.models';
import { MarketCustomerAnalysisWidgetService } from '../services/market-customer-analysis-widget.service';
import { IMarketCustomerAnalysisWidgetContent } from './market-customer-analysis-widget-content.models';


@Component({
  selector: 'dashboard-market-customer-analysis-widget-content',
  templateUrl: './market-customer-analysis-widget-content.component.html',
  styleUrls: ['./market-customer-analysis-widget-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    ProgressBarComponent,
  ],
})
export class MarketCustomerAnalysisWidgetContentComponent extends BaseWidgetTypeContentComponent<MarketCustomerAnalysisWidgetTypeConfig> {
  @HostBinding('class') class =
    'dashboard-market-customer-analysis-widget-content';
  public data$: Observable<IMarketCustomerAnalysisWidgetContent>;
  public isLoading$ = new BehaviorSubject<boolean>(false);
  public layout$: Observable<MarketCustomerAnalysisWidgetLayout>;

  public constructor(injector: Injector) {
    super();

    const service = injector.get(MarketCustomerAnalysisWidgetService);

    this.layout$ = this.configObservable.pipe(
      map((value) => value?.layout ?? 'auto'),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.data$ = this.configObservable.pipe(
      map((value) => value?.companyId),
      filter((companyId): companyId is NonNullable<typeof companyId> =>
        Boolean(companyId),
      ),
      distinctUntilChanged(),
      switchMap((companyId) =>
        service
          .dashboardCustomerOverviewById$({ companyId })
          .pipe(indicate(this.isLoading$)),
      ),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

  }

}
